var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTravel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "19px",
    viewBox: "0 0 26 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTravel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.8531212,2575.10671 L36.7106292,2575.4698 L30.5318741,2567.82182 C30.3373141,2567.62746 30.0730453,2567.51891 29.7973318,2567.51891 L28.9889192,2567.51891 C28.6018799,2567.51891 28.3511367,2567.92313 28.5238478,2568.26739 L29.9735423,2575.59834 L21.86579,2575.58154 L19.9189633,2573.67281 C19.6911096,2573.16314 18.9232736,2573.32441 18.9232736,2573.88267 L18.9232736,2575.58226 L18.9232736,2578.68369 L18.8939346,2580.72894 C18.8939346,2581.2872 19.6617705,2581.44951 19.8896243,2580.9388 L21.86579,2578.75534 L29.9735423,2579.08848 L29.9849135,2587.11909 C29.8122024,2587.46335 30.0629456,2587.86757 30.4499849,2587.86757 L31.2583976,2587.86757 C31.534111,2587.86757 31.7994202,2587.75902 31.9939803,2587.56466 L36.1898434,2579.32605 L43.0996768,2578.58022 C44.2420669,2578.60296 45.2651271,2577.50952 45.0198928,2576.59429 C44.7746585,2575.67907 43.9955113,2575.08396 42.8531212,2575.10671 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-7",
    transform: "translate(-18.000000, -2569.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icTravel",
    fill: "#646464",
    fillRule: "nonzero",
    transform: "translate(31.975252, 2577.693239) rotate(-30.000000) translate(-31.975252, -2577.693239) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTravel);
export default __webpack_public_path__ + "static/media/icTravel.5e35a19b55649ccf47c41d0beac4185a.svg";
export { ForwardRef as ReactComponent };